import { PresentationType } from "../presentationType";

export abstract class BinaryPresentation extends PresentationType {
    public getAllowedCharacters(): string[] {
        return this.getNumbersFromZeroTo(1);
    }
}